import { Facebook, Instagram, Linkedin, Mail, Phone } from 'lucide-react';
import { useEffect } from 'react';

const Team = () => {
  useEffect(() => {
    document.title = 'Tim Kami - CV Samudera Alam Perkasa';
    window.scrollTo(0, 0);
  }, []);

  const teamMembers = [
    {
      id: 1,
      name: 'Hendro Wijaya',
      position: 'CEO & Founder',
      image: 'https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg?auto=compress&cs=tinysrgb&w=1600',
      bio: 'Berpengalaman lebih dari 15 tahun dalam industri ketenagakerjaan dengan visi memajukan kualitas SDM Indonesia. Hendro mendirikan CV Samudera Alam Perkasa pada tahun 2012 dan telah memimpin perusahaan menjadi salah satu penyedia layanan tenaga kerja terkemuka di Indonesia.',
      education: 'S2 Manajemen, Universitas Indonesia',
      expertise: ['Manajemen Strategis', 'Pengembangan Bisnis', 'Kepemimpinan'],
      contact: {
        email: 'hendro@samuderaalam.com',
        phone: '+62812XXXXXXX',
      },
      social: {
        linkedin: '#',
        facebook: '#',
        instagram: '#',
      },
    },
    {
      id: 2,
      name: 'Anita Susanti',
      position: 'COO',
      image: 'https://images.pexels.com/photos/3796217/pexels-photo-3796217.jpeg?auto=compress&cs=tinysrgb&w=1600',
      bio: 'Ahli dalam operasional perusahaan dengan fokus pada efisiensi dan peningkatan kualitas layanan. Anita bergabung dengan CV Samudera Alam Perkasa pada tahun 2015 dan telah berperan penting dalam mengembangkan sistem operasional yang efektif untuk memastikan pelayanan terbaik bagi klien.',
      education: 'S1 Manajemen Bisnis, Universitas Airlangga',
      expertise: ['Manajemen Operasional', 'Optimasi Proses', 'Manajemen Kualitas'],
      contact: {
        email: 'anita@samuderaalam.com',
        phone: '+62813XXXXXXX',
      },
      social: {
        linkedin: '#',
        facebook: '#',
        instagram: '#',
      },
    },
    {
      id: 3,
      name: 'Dimas Prasetyo',
      position: 'CMO',
      image: 'https://images.pexels.com/photos/2379005/pexels-photo-2379005.jpeg?auto=compress&cs=tinysrgb&w=1600',
      bio: 'Pakar pemasaran dan pengembangan bisnis dengan jaringan luas di berbagai industri di Indonesia. Dimas memiliki pengalaman lebih dari 10 tahun dalam bidang pemasaran dan telah membantu CV Samudera Alam Perkasa memperluas jangkauan pasar dan membangun hubungan kuat dengan klien.',
      education: 'S1 Marketing, Universitas Brawijaya',
      expertise: ['Strategi Pemasaran', 'Pengembangan Bisnis', 'Hubungan Klien'],
      contact: {
        email: 'dimas@samuderaalam.com',
        phone: '+62815XXXXXXX',
      },
      social: {
        linkedin: '#',
        facebook: '#',
        instagram: '#',
      },
    },
    {
      id: 4,
      name: 'Rini Hartati',
      position: 'HRD Manager',
      image: 'https://images.pexels.com/photos/1181686/pexels-photo-1181686.jpeg?auto=compress&cs=tinysrgb&w=1600',
      bio: 'Spesialis sumber daya manusia dengan keahlian dalam rekrutmen dan pengembangan talenta. Rini telah berkontribusi signifikan dalam membangun tim CV Samudera Alam Perkasa dan memastikan standar kualitas tinggi dalam proses rekrutmen untuk klien.',
      education: 'S1 Psikologi, Universitas Gadjah Mada',
      expertise: ['Rekrutmen', 'Pengembangan Talenta', 'Manajemen SDM'],
      contact: {
        email: 'rini@samuderaalam.com',
        phone: '+62817XXXXXXX',
      },
      social: {
        linkedin: '#',
        facebook: '#',
        instagram: '#',
      },
    },
    {
      id: 5,
      name: 'Agus Santoso',
      position: 'Training Manager',
      image: 'https://images.pexels.com/photos/2182970/pexels-photo-2182970.jpeg?auto=compress&cs=tinysrgb&w=1600',
      bio: 'Ahli pengembangan keterampilan dan program pelatihan dengan pendekatan inovatif. Agus mengembangkan dan mengelola program pelatihan komprehensif untuk meningkatkan keterampilan tenaga kerja yang disalurkan oleh CV Samudera Alam Perkasa.',
      education: 'S2 Pendidikan, Universitas Negeri Surabaya',
      expertise: ['Pengembangan Kurikulum', 'Pelatihan Keterampilan', 'Evaluasi Kinerja'],
      contact: {
        email: 'agus@samuderaalam.com',
        phone: '+62819XXXXXXX',
      },
      social: {
        linkedin: '#',
        facebook: '#',
        instagram: '#',
      },
    },
    {
      id: 6,
      name: 'Linda Wijaya',
      position: 'Finance Manager',
      image: 'https://images.pexels.com/photos/1587009/pexels-photo-1587009.jpeg?auto=compress&cs=tinysrgb&w=1600',
      bio: 'Profesional keuangan dengan keahlian dalam manajemen keuangan dan penggajian. Linda mengelola seluruh aspek keuangan perusahaan termasuk sistem penggajian untuk tenaga kerja yang dikelola oleh CV Samudera Alam Perkasa.',
      education: 'S1 Akuntansi, Universitas Airlangga',
      expertise: ['Manajemen Keuangan', 'Sistem Penggajian', 'Pelaporan Keuangan'],
      contact: {
        email: 'linda@samuderaalam.com',
        phone: '+62821XXXXXXX',
      },
      social: {
        linkedin: '#',
        facebook: '#',
        instagram: '#',
      },
    },
  ];

  return (
    <>
      {/* Page Header */}
      <div className="bg-navy-900 text-white py-20 mt-16">
        <div className="container-custom">
          <h1 className="text-4xl font-bold mb-4">Tim Kami</h1>
          <p className="text-lg text-gray-300 max-w-3xl">
            Kenali para profesional di balik layanan CV Samudera Alam Perkasa yang berdedikasi untuk
            memberikan solusi tenaga kerja terbaik.
          </p>
        </div>
      </div>

      {/* Leadership Team */}
      <section className="py-16">
        <div className="container-custom">
          <div className="text-center mb-16">
            <h2 className="section-title mx-auto inline-block after:left-1/2 after:-translate-x-1/2">
              Tim Kepemimpinan
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto mt-6">
              Dipimpin oleh para profesional berpengalaman yang berkomitmen untuk keunggulan dan inovasi.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {teamMembers.slice(0, 3).map((member) => (
              <div
                key={member.id}
                className="card group overflow-hidden"
              >
                <div className="relative overflow-hidden">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-80 object-cover object-center transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-navy-900/90 to-transparent p-6 transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
                    <div className="flex justify-center space-x-4 mb-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <a
                        href={member.social.linkedin}
                        className="text-white hover:text-yellow-500 transition-colors"
                        aria-label="LinkedIn"
                      >
                        <Linkedin size={18} />
                      </a>
                      <a
                        href={member.social.facebook}
                        className="text-white hover:text-yellow-500 transition-colors"
                        aria-label="Facebook"
                      >
                        <Facebook size={18} />
                      </a>
                      <a
                        href={member.social.instagram}
                        className="text-white hover:text-yellow-500 transition-colors"
                        aria-label="Instagram"
                      >
                        <Instagram size={18} />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-1 text-navy-900">
                    {member.name}
                  </h3>
                  <p className="text-primary-600 font-medium mb-3">{member.position}</p>
                  <p className="text-gray-600 mb-4 line-clamp-3">{member.bio}</p>
                  <div className="flex flex-wrap gap-2 mb-4">
                    {member.expertise.map((skill, index) => (
                      <span 
                        key={index}
                        className="px-2 py-1 bg-gray-100 text-navy-900 text-xs rounded-md"
                      >
                        {skill}
                      </span>
                    ))}
                  </div>
                  <div className="space-y-1 text-sm">
                    <div className="flex items-center text-gray-600">
                      <Mail size={16} className="mr-2 text-primary-600" />
                      <span>{member.contact.email}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Core Team */}
      <section className="py-16 bg-gray-50">
        <div className="container-custom">
          <div className="text-center mb-16">
            <h2 className="section-title mx-auto inline-block after:left-1/2 after:-translate-x-1/2">
              Tim Inti
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto mt-6">
              Para ahli yang mendukung operasional harian dan memastikan layanan berkualitas.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {teamMembers.slice(3).map((member) => (
              <div
                key={member.id}
                className="card group overflow-hidden"
              >
                <div className="relative overflow-hidden">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-80 object-cover object-center transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-navy-900/90 to-transparent p-6 transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
                    <div className="flex justify-center space-x-4 mb-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <a
                        href={member.social.linkedin}
                        className="text-white hover:text-yellow-500 transition-colors"
                        aria-label="LinkedIn"
                      >
                        <Linkedin size={18} />
                      </a>
                      <a
                        href={member.social.facebook}
                        className="text-white hover:text-yellow-500 transition-colors"
                        aria-label="Facebook"
                      >
                        <Facebook size={18} />
                      </a>
                      <a
                        href={member.social.instagram}
                        className="text-white hover:text-yellow-500 transition-colors"
                        aria-label="Instagram"
                      >
                        <Instagram size={18} />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-1 text-navy-900">
                    {member.name}
                  </h3>
                  <p className="text-primary-600 font-medium mb-3">{member.position}</p>
                  <p className="text-gray-600 mb-4 line-clamp-3">{member.bio}</p>
                  <div className="flex flex-wrap gap-2 mb-4">
                    {member.expertise.map((skill, index) => (
                      <span 
                        key={index}
                        className="px-2 py-1 bg-gray-100 text-navy-900 text-xs rounded-md"
                      >
                        {skill}
                      </span>
                    ))}
                  </div>
                  <div className="space-y-1 text-sm">
                    <div className="flex items-center text-gray-600">
                      <Mail size={16} className="mr-2 text-primary-600" />
                      <span>{member.contact.email}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Company Culture */}
      <section className="py-16">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="section-title">Budaya Perusahaan</h2>
              <p className="text-gray-600 mb-6">
                Di CV Samudera Alam Perkasa, kami membangun budaya kerja yang berlandaskan nilai-nilai 
                utama yang menjadi pedoman kami dalam memberikan layanan terbaik.
              </p>
              
              <div className="space-y-6">
                {[
                  {
                    title: 'Integritas',
                    description: 'Kami menjalankan bisnis dengan kejujuran dan etika yang tinggi dalam setiap aspek pekerjaan kami.',
                  },
                  {
                    title: 'Profesionalisme',
                    description: 'Kami berkomitmen untuk memberikan layanan berkualitas tinggi dengan standar profesional tertinggi.',
                  },
                  {
                    title: 'Inovasi',
                    description: 'Kami terus mengembangkan pendekatan baru untuk meningkatkan layanan dan memberikan solusi terbaik.',
                  },
                  {
                    title: 'Kolaborasi',
                    description: 'Kami bekerja sama sebagai tim dan dengan klien untuk mencapai hasil terbaik bagi semua pihak.',
                  },
                ].map((value, index) => (
                  <div key={index} className="bg-gray-50 p-4 rounded-lg border-l-4 border-primary-600">
                    <h3 className="font-bold text-navy-900 mb-1">{value.title}</h3>
                    <p className="text-gray-600">{value.description}</p>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="grid grid-cols-2 gap-4">
              <img 
                src="https://images.pexels.com/photos/3182774/pexels-photo-3182774.jpeg?auto=compress&cs=tinysrgb&w=1600" 
                alt="Team meeting" 
                className="rounded-lg shadow-md w-full h-auto"
              />
              <img 
                src="https://images.pexels.com/photos/3205568/pexels-photo-3205568.jpeg?auto=compress&cs=tinysrgb&w=1600" 
                alt="Team collaboration" 
                className="rounded-lg shadow-md w-full h-auto mt-8"
              />
              <img 
                src="https://images.pexels.com/photos/1181622/pexels-photo-1181622.jpeg?auto=compress&cs=tinysrgb&w=1600" 
                alt="Team discussion" 
                className="rounded-lg shadow-md w-full h-auto"
              />
              <img 
                src="https://images.pexels.com/photos/1181391/pexels-photo-1181391.jpeg?auto=compress&cs=tinysrgb&w=1600" 
                alt="Office environment" 
                className="rounded-lg shadow-md w-full h-auto mt-8"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Join the Team */}
      <section className="py-16 bg-primary-600 text-white">
        <div className="container-custom text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Bergabunglah dengan Tim Kami</h2>
          <p className="text-xl text-white/80 max-w-3xl mx-auto mb-8">
            Kami selalu mencari talenta berbakat untuk bergabung dengan tim kami. Kirimkan CV Anda jika 
            Anda tertarik menjadi bagian dari perjalanan kami.
          </p>
          <a
            href="/contact"
            className="btn bg-white text-primary-600 hover:bg-yellow-500 hover:text-white"
          >
            Kirim Lamaran
          </a>
        </div>
      </section>
    </>
  );
};

export default Team;